/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrdinamentoScolastico } from './ordinamento-scolastico';


export interface TipoPraticaIstitutoPlessoListFilter { 
    nome?: string;
    ordinamento?: OrdinamentoScolastico;
    codice_meccanografico?: string;
    attivo?: boolean;
    q?: string;
}



